import {
  ApiDeleteRequest,
  ApiGetRequest,
  ApiPostRequest,
  ApiPutRequest,
} from '../../../api';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Estimate Cost',
    title_form: 'Form Estimate Cost',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'PTI',
        href: '/opc/pti/estimate-cost',
        active: true,
      },
    ],
    items: [],
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'age',
    sortDesc: true,
    fields: [
      {
        key: 'code_pti',
        label: 'PTI',
        sortable: true,
      },
      {
        key: 'pti_date',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'app_by',
        label: 'App',
      },
      {
        key: 'app_code',
        label: 'App No',
      },
      {
        key: 'total_pti',
        label: 'Total EOR',
      },
      {
        key: 'total_app',
        label: 'Total App',
      },
      {
        key: 'status_pti',
        label: 'Status',
      },
      {
        key: 'aksi',
      },
    ],
    fields_choose_container: [
      {
        key: 'code_survey',
        label: 'Survey',
        sortable: true,
      },
      {
        key: 'survey_date',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'B/L No',
        sortable: true,
      },
      {
        key: 'exvessel_voy',
        label: 'Exvessel/Voy',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'cleaning',
        label: 'Cleaning',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    items_survey: [],
    form: {
      id_principle: '',
      code_principle: '',
      principle: '',
      containers: [],
    },
    form_approve: {},
    form_damage: {
      loc: '',
      comp: '',
      dmg_width: '',
      dmg_height: '',
      dmg_unit: '',
      qty: '',
      account: '',
      dmg_type: '',
      action_repair: '',
      photo_damage: [],
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  form_approve(state) {
    return state.data.form_approve;
  },
  form_damage(state) {
    return state.data.form_damage;
  },
};

export const mutations = {
  changePtiEstimate(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getListPti({ commit, state }) {
    commit('changePtiEstimate', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      status_approval: data.status_approval || '',
    };

    if (data.daterange && data.daterange.length > 0) {
      params.start_date = data.daterange[0]
        ? moment(data.daterange[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.daterange[1]
        ? moment(data.daterange[1]).format('YYYY-MM-DD')
        : '';
    }

    let result = await ApiGetRequest(`opr/pti`, params);
    commit('changePtiEstimate', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDownloadFiles({ commit }, payload = null) {
    commit('changeEor', {
      loading: true,
    });

    let result = await ApiPostRequest('opr/download', {
      ...payload,
    });

    commit('changeEor', {
      loading: false,
    });
    if (result) {
      return result.data.object;
    }
  },

  async getListContSurvey({ commit, state }) {
    commit('changePtiEstimate', {
      loading: true,
    });

    const { data } = state;
    let container_id = [];
    data.form.containers.map((item) => container_id.push(item.id_container));

    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: data.form.id_principle || '',
      containers: container_id ? container_id.join(',') : '',
    };

    let result = await ApiGetRequest(`opr/pti/survey`, params);
    commit('changePtiEstimate', {
      items_survey: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailContainerEOR({ commit }, payload = null) {
    commit('changePtiEstimate', {
      loading: true,
    });

    // const { data } = state;
    let result = await ApiGetRequest(`opr/pti/container/${payload.id}`);
    commit('changePtiEstimate', {
      loading: false,
    });

    if (!result.error) {
      let object_data = result.data.object;

      // kalau udah di submission set app data = submission data defaultnya
      if (object_data.status_pti === 2) {
        object_data.damages.map((item, index) => {
          object_data.damages[index].app_hour = item.hour;
          object_data.damages[index].app_labour_rate = item.labour_rate;
          object_data.damages[index].app_total_labour = item.total_labour;
          object_data.damages[index].app_material_cost = item.material_cost;
          object_data.damages[index].app_total_material = item.total_material;
          object_data.damages[index].app_cost_vendor = item.cost_vendor;
          object_data.damages[index].total_item_app = item.total_item;
          object_data.damages[index].checked = 1;
        });

        object_data.total_app = object_data.total_estimate || 0;
      } else if (object_data.status_pti <= 1) {
        let total_estimate = 0;
        object_data.damages.map((item, index) => {
          if (!item.total_item) {
            object_data.damages[index] = {
              ...item,
              ...payload.data.damages[index],
            };
          }

          object_data.damages[index].app_hour = 0;
          object_data.damages[index].app_labour_rate = 0;
          object_data.damages[index].app_total_labour = 0;
          object_data.damages[index].app_material_cost = 0;
          object_data.damages[index].app_total_material = 0;
          object_data.damages[index].app_cost_vendor = 0;
          object_data.damages[index].total_item_app = 0;
          object_data.damages[index].checked = 0;
          object_data.damages[index].disc = object_data.damages[index].disc
            ? object_data.damages[index].disc
            : 0;
          object_data.damages[index].is_approve = object_data.damages[index]
            .is_approve
            ? object_data.damages[index].is_approve
            : 0;

          total_estimate += +object_data.damages[index].total_item;
        });

        if (
          parseFloat(object_data.total_item) !== parseFloat(total_estimate) ||
          !object_data.total_item
        ) {
          object_data.material = 0;
          object_data.total_estimate = total_estimate;
          object_data.total_item = total_estimate;
          object_data.disc_persentase = object_data.disc_persentase
            ? object_data.disc_persentase
            : 0;
          object_data.disc_nominal = object_data.disc_nominal
            ? object_data.disc_nominal
            : 0;
        }
      }

      commit('changePtiEstimate', {
        form_approve: {
          ...object_data,
        },
      });
    }

    return !result.error ? true : false;
  },

  async getDetailEOR({ commit }, payload = null) {
    commit('changePtiEstimate', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/pti/${payload.id}`);
    commit('changePtiEstimate', {
      loading: false,
    });

    if (!result.error) {
      commit('changePtiEstimate', {
        form: {
          ...result.data.object,
          app_date: result.data.object.app_date
            ? moment(result.data.object.app_date).format('DD/MM/YYYY')
            : null,
        },
      });
    }

    return !result.error ? true : false;
  },

  async createEOR({ commit, state, dispatch }, payload = null) {
    commit('changePtiEstimate', {
      loading: true,
    });

    const { data } = state;
    if (
      payload.type &&
      (payload.type === 'submission' || payload.type === 'approve')
    ) {
      data.form['submit_type'] = payload.type;
    }

    let result = await ApiPostRequest(`opr/pti`, data.form);
    commit('changePtiEstimate', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateEOR({ commit, state, dispatch }, payload = null) {
    commit('changePtiEstimate', {
      loading: true,
    });

    const { data } = state;
    if (
      payload.type &&
      (payload.type === 'submission' || payload.type === 'approve')
    ) {
      data.form['submit_type'] = payload.type;
    }

    console.log(payload, data.form.submit_type);

    let result = await ApiPutRequest(`opr/pti/${payload.id}`, data.form);
    commit('changePtiEstimate', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async deletePTI({ commit, dispatch }, payload = null) {
    commit('changePtiEstimate', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/pti/${payload.id}`);
    commit('changePtiEstimate', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },
};
